<template>
  <avs-card
    color="blue"
    height="310"
    noTitle
  >
    <template v-slot:content>
      <v-row no-gutters>
        <v-col
          class="py-8 px-4"
          cols="3"
        >
          <div class="d-flex flex-column white--text">
            <avs-editButton
              v-if="!isOperator(project.role)"
              classB="white--text"
              :spantext="tooltip"
              @click.stop="toProjectEdit"
            />
            <span class="mt-4 text-h5">
              <b>{{ project.name }}</b>
            </span>
          </div>
        </v-col>
        <v-col cols="9">
          <v-img
            class="full-width-image"
            height="310"
            :src="picture"
          />
        </v-col>
      </v-row>
    </template>
  </avs-card>
</template>

<script>
import { toDate } from "@/utils/datetime"
import { isOperator } from "@/utils/middleware"

export default {
  name: "ProjectName",
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  computed: {
    picture() {
      return this.project.picture || this.$appConfig.assets.img.common.cover
    },
    tooltip() {
      return this.$t("actions.edit", {
        entity: this.$tc("categories.project.name", 1).toLowerCase()
      })
    }
  },
  methods: {
    toDate,
    isOperator,
    toProjectEdit() {
      let projectId = this.project.id
      this.$router.push({ name: "ProjectCreateUpdate", params: { id: projectId } })
    }
  }
}
</script>

<style scoped>
.col {
  text-align: left;
}

.full-width-image {
  width: 100%;
  border-top-right-radius: 16px;
  border-bottom-right-radius: 16px;
}
</style>
